import type { HelpTopic } from '@horof/shared';

/** «؟ مساعدة», screen by screen (doc 52): short steps, the buttons' words. */
export const HELP: HelpTopic[] = [
  {
    path: '/month',
    title: 'حالة الشهر',
    steps: [
      'اختر الشهر بالسهمين.',
      'كل خطوة تُظهر ما انتهى وما بقي: القراءات، الفواتير، واتساب، النشر.',
      'الفواتير وإغلاق الشهر تُعدّ من الحاسوب («مكتب الجمعية»).',
      'النشر: افتح الصور ثم شاركها في مجموعة واتساب.',
    ],
  },
  {
    path: '/members/*',
    title: 'الأعضاء',
    steps: [
      'ابحث عن العضو بالاسم أو برقم العداد أو بالهاتف.',
      'افتح العضو لترى عداداته وفواتيره وهاتفه.',
      '«تعديل المعلومات» لتصحيح الاسم أو الهاتف أو طريقة التواصل.',
      'الشرط وحالة العضو (مغادرة) من الحاسوب.',
    ],
  },
  {
    path: '/members',
    title: 'الأعضاء',
    steps: [
      'ابحث عن العضو بالاسم أو برقم العداد أو بالهاتف.',
      'افتح العضو لترى عداداته وفواتيره وهاتفه.',
      '«عضو جديد» لإضافة عضو، ثم «إضافة عداد (مع صورته)» من صفحته.',
    ],
  },
  {
    path: '/meters/new',
    title: 'عداد جديد',
    steps: [
      'اختر العضو واكتب رقم العداد.',
      'صوّر العداد بحيث يظهر رقمه وقراءته الأولى بوضوح.',
      'اضغط «إضافة العداد».',
    ],
  },
  {
    path: '/meters/*',
    title: 'العدادات',
    steps: [
      'ابحث بالرقم أو باسم العضو أو بالعنوان.',
      '«غير مربوطة»: عدادات ليست في الجولة.',
      'عداد ركّبته في الميدان؟ اضغط «عداد جديد» وصوّره.',
    ],
  },
  {
    path: '/meters',
    title: 'العدادات',
    steps: [
      'ابحث بالرقم أو باسم العضو أو بالعنوان.',
      '«غير مربوطة»: عدادات ليست في الجولة.',
      'عداد ركّبته في الميدان؟ اضغط «عداد جديد» وصوّره.',
    ],
  },
  {
    path: '/reports',
    title: 'التقارير',
    steps: [
      '«تذكيرات اليوم»: من يجب تذكيره اليوم.',
      '«المتأخرون عن الأداء»: القائمة كاملة.',
      'التقرير الأسبوعي للجنة وأمين المال فقط.',
      'التقارير الأخرى على الحاسوب.',
    ],
  },
  {
    path: '/reports/reminders',
    title: 'تذكيرات اليوم',
    steps: [
      'اضغط «تذكير»: يفتح واتساب برسالة جاهزة، ثم أرسلها.',
      'يُسجَّل التذكير حتى لا يُذكَّر العضو مرتين.',
    ],
  },
  {
    path: '/reports/arrears',
    title: 'المتأخرون عن الأداء',
    steps: [
      'كل عضو متأخر، ومبلغه ومنذ متى.',
      '«اللائحة العامة»: من تُنشر أسماؤهم.',
      '«بدون هاتف»: أعضاء لا يُذكَّرون بالهاتف.',
    ],
  },
  {
    path: '/documents',
    title: 'الوثائق',
    steps: [
      'ابحث عن الوثيقة بالعنوان أو المرجع أو الجهة، ثم افتحها.',
      '«تنتظر الرد»: رسائل مرّ موعد ردها.',
      'وثيقة ورقية جديدة؟ اضغط «تصوير وثيقة».',
    ],
  },
  {
    path: '/documents/scan',
    title: 'تصوير وثيقة',
    steps: [
      'صوّر كل صفحة وحدها، بالترتيب، في مكان مضيء.',
      'بعد كل صورة اضغط «تصوير صفحة أخرى»، ثم «انتهيت».',
      'اختر نوع الوثيقة واكتب عنواناً قصيراً، ثم «حفظ الوثيقة».',
      'الرسائل تأخذ رقمها تلقائياً.',
    ],
  },
  {
    path: '/documents/:documentId',
    title: 'الوثيقة',
    steps: ['اضغط على صفحة لتكبيرها.', 'التعديل وترتيب الصفحات من الحاسوب.'],
  },
  {
    path: '/bills/:billId',
    title: 'الفاتورة',
    steps: ['تفاصيل الفاتورة: القراءة والاستهلاك والمبلغ.'],
  },
];
